
import React,{useRef,useEffect} from 'react';
import {Link } from 'react-router-dom'
import {
    Button,
    Container,
    Divider,
    Dropdown,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
} from 'semantic-ui-react'


function MainMenu()
{
    var menuItem = (text,link) =><Link to={link}><Menu.Item >{text}</Menu.Item></Link>
    return  <Menu fixed='top' inverted size='large'> 
      <Container>
        {menuItem("Home",'/')}
        {menuItem("Gifs",'/details')}
        {menuItem("Screenshots",'/screenshots')}
        {menuItem("Support",'/support')} 
      </Container>
    </Menu>
}

export default MainMenu